import React, { useEffect, useState } from "react";
import {
  Box,
  makeStyles,
  Typography,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
} from "@material-ui/core";
import { useParams, useHistory } from "react-router-dom";
import { useLazyQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import moment from "moment";

import { useAlert } from "../../components/Alert";

const GET_FORECLOSURES = gql`
  query foreclosures(
    $obj_court: String
    $obj_date_ymd_from: Date
    $obj_date_ymd_to: Date
    $obj_time: [String]
    $period: Period
    $source: [String]
    $orderBy: OrderBy
    $desc: Boolean
  ) {
    foreclosures(
      obj_court: $obj_court
      obj_date_ymd_from: $obj_date_ymd_from
      obj_date_ymd_to: $obj_date_ymd_to
      obj_time: $obj_time
      period: $period
      source: $source
      orderBy: $orderBy
      desc: $desc
    ) {
      count
      pageCount
      contents {
        obj_str
        obj_share
        obj_caseno
        obj_another
        obj_date_hi
        obj_date_ymd
        obj_type
        obj_time
        obj_city
        obj_area
        obj_section
        obj_section_s
        obj_landno
        obj_address
        obj_margin
        obj_price
        obj_debtor
        obj_build_floor
        obj_land_floor
        obj_total_floor
        obj_c_floor
        obj_remark
      }
    }
  }
`;

export default function PropertyTablePrint() {
  const [am, setAm] = useState([]);
  const [pm, setPm] = useState([]);
  const [amCount, setAmCount] = useState(0);
  const [pmCount, setPmCount] = useState(0);
  const Alert = useAlert();
  const printData = JSON.parse(localStorage.getItem("@fullhousePrint"));
  const useStyles = makeStyles((theme) => ({
    formBox: {
      width: "80%",
      maxHeight: "1754px",
      minHeight: "100vh",
      margin: "0 auto",
      //   paddingLeft: "200px",
    },

    // table
    table: {
      width: "100%",
      minWidth: "900px",
      "& th": {
        padding: "5px 3px",
        border: "1px solid grey",
        whiteSpace: "nowrap",
      },
      "& td": {
        padding: "5px 3px",
        border: "1px solid grey",
      },
    },
  }));
  const classes = useStyles();

  function print_action() {
    var restorepage = document.body.innerHTML;
    var printcontent = document.getElementById("printable").innerHTML;
    document.body.innerHTML = printcontent;
    window.print();
    document.body.innerHTML = restorepage;
    window.location.reload();
  }

  const [getForeclosures, { data, loading }] = useLazyQuery(GET_FORECLOSURES, {
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    onCompleted({ foreclosures }) {
      if (foreclosures) {
        let amArray = [];
        let pmArray = [];
        let amCutArray = [];
        let pmCutArray = [];
        let amDataArray = [];
        let pmDataArray = [];
        let amStartIndex = 0;
        let amEndIndex;
        let amRowCount;
        let pmStartIndex = 0;
        let pmEndIndex;
        let pmRowCount;
        let amCount = 0;
        let pmCount = 0;
        foreclosures.contents.forEach((item) => {
          if (Number(moment(item.obj_date_hi).utc().format("HH")) <= 11)
            amArray.push(item);
          else pmArray.push(item);
        });
        //TODO
        amArray.forEach((item, index) => {
          if (amArray[index]?.obj_share !== amArray[index + 1]?.obj_share) {
            amEndIndex = index;
            amRowCount =
              amStartIndex === 0
                ? amEndIndex - amStartIndex + 1
                : amEndIndex - amStartIndex;
            amDataArray = [];
            for (
              let i = amStartIndex === 0 ? amStartIndex : amStartIndex + 1;
              i <= amEndIndex;
              i++
            ) {
              amDataArray.push(amArray[i]);
            }
            amStartIndex = amEndIndex;
            amCutArray.push({
              obj_share: `${
                amArray[amStartIndex === 1 ? 0 : amStartIndex]?.obj_share
              }`,
              rowLength: amRowCount,
              data: amDataArray,
            });
          }
        });
        pmArray.forEach((item, index) => {
          if (pmArray[index]?.obj_share !== pmArray[index + 1]?.obj_share) {
            pmEndIndex = index;
            pmRowCount =
              pmStartIndex === 0
                ? pmEndIndex - pmStartIndex + 1
                : pmEndIndex - pmStartIndex;
            pmDataArray = [];
            for (
              let i = pmStartIndex === 0 ? pmStartIndex : pmStartIndex + 1;
              i <= pmEndIndex;
              i++
            ) {
              pmDataArray.push(pmArray[i]);
            }
            pmStartIndex = pmEndIndex;
            pmCutArray.push({
              obj_share: `${
                pmArray[pmStartIndex === 1 ? 0 : pmStartIndex]?.obj_share
              }`,
              rowLength: pmRowCount,
              data: pmDataArray,
            });
          }
        });
        amCutArray.map((item) => (amCount += item.data.length));
        pmCutArray.map((item) => (pmCount += item.data.length));
        setAm(amCutArray);
        setPm(pmCutArray);
        setAmCount(amCount);
        setPmCount(pmCount);
      }
    },
    onError(error) {
      Alert.alert("通知", `${error}`, [
        {
          text: "確定",
          type: "ok",
        },
      ]);
    },
  });
  useEffect(() => {
    if (Boolean(localStorage.getItem("@fullhousePrint"))) {
      getForeclosures({
        variables: {
          obj_court: printData.courtObject.value,
          obj_date_ymd_from: moment(printData.summaryTableBillingDate).toDate(),
          obj_date_ymd_to: moment(printData.summaryTableBillingDate).toDate(),
          obj_time:
            printData.timeObject.value === "during"
              ? ["0", "during"]
              : undefined,
          period: printData.timePeriod,
          source: [printData.sourceObj.value],
          orderBy: "OBJ_SHARE",
          desc: true,
        },
      });
    }
  }, [localStorage.getItem("@fullhousePrint")]);
  if (loading) {
    return (
      <Grid container justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  }
  if (Boolean(data)) {
    //table
    return (
      <Box className={classes.formBox}>
        <Button
          color="primary"
          variant="contained"
          className="no-print"
          onClick={print_action}
        >
          列印
        </Button>
        <Box my={4} id="printable">
          {/* Title */}
          {(printData.timePeriod === "ALL" ||
            printData.timePeriod === "AM") && (
            <>
              <Grid container spacing={2}>
                <Grid item>
                  <img
                    src={"/assets/images/Home/fullLogo2.jpg"}
                    style={{
                      maxWidth: "250px",
                      maxHeight: "88px",
                      objectFit: "contain",
                    }}
                  />
                </Grid>
                <Grid item style={{ flex: 1 }}>
                  <Typography> https://new.5137.com.tw</Typography>
                  <Typography>台中市南屯區大英西一街61號</Typography>
                  <Typography>(04)24717673</Typography>
                </Grid>
                <Grid item>
                  <Typography>{printData.courtObject.label}</Typography>
                  <Typography>{`開標時間${moment(
                    printData.summaryTableBillingDate
                  ).format("yyyy-MM-DD")} ${
                    printData.timeObject.value === "during"
                      ? ""
                      : printData.sourceObj.value === "臺灣金服"
                      ? "11:00"
                      : "10:00"
                  }`}</Typography>
                  <Typography>{`資料筆數：${amCount}筆`}</Typography>
                </Grid>
              </Grid>
              <Box mt={2}>
                <TableContainer component={Paper}>
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell align={"center"}>股別</TableCell>
                        <TableCell align={"center"}>案號</TableCell>
                        <TableCell align={"center"}>債務人</TableCell>
                        <TableCell align={"center"}>拍次</TableCell>
                        <TableCell align={"center"}>地址</TableCell>
                        <TableCell align={"center"}>建坪單價</TableCell>
                        <TableCell align={"center"}>地坪單價</TableCell>
                        <TableCell align={"center"}>建坪</TableCell>
                        <TableCell align={"center"}>地坪</TableCell>
                        <TableCell align={"center"}>拍賣底價</TableCell>
                        <TableCell align={"center"}>保證金</TableCell>
                        <TableCell align={"center"}>公設比</TableCell>
                        <TableCell align={"center"}>備註</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {am.map((item, index) => (
                        <>
                          <TableRow>
                            <TableCell
                              rowSpan={item.rowLength + 1}
                              align={"center"}
                            >
                              {item.obj_share}
                            </TableCell>
                          </TableRow>
                          {item.data.map((item2) => (
                            <TableRow key={index}>
                              <TableCell align={"left"}>
                                {item2.obj_str +
                                  "年" +
                                  item2.obj_caseno +
                                  (!!item2.obj_another &&
                                  item2.obj_another.indexOf("(") === -1 &&
                                  item2.obj_another.indexOf("-") === -1
                                    ? "(" + item2.obj_another + ")"
                                    : item2.obj_another)}
                              </TableCell>
                              <TableCell align={"center"}>
                                {item2.obj_debtor.length > 3
                                  ? item2.obj_debtor.substr(0, 3) + "..."
                                  : item2.obj_debtor}
                              </TableCell>
                              <TableCell align={"center"}>
                                {item2.obj_time === "0"
                                  ? "應買"
                                  : item2.obj_time}
                              </TableCell>
                              <TableCell>
                                {item2.obj_type === "H"
                                  ? item2.obj_city +
                                    item2.obj_area +
                                    item2.obj_address
                                  : item2.obj_city +
                                    item2.obj_area +
                                    item2.obj_section +
                                    "段" +
                                    item2.obj_section_s +
                                    (item2.obj_section_s ? "小段" : "") +
                                    item2.obj_landno +
                                    (item2.obj_landno ? "地號" : "")}
                              </TableCell>
                              <TableCell align={"right"}>
                                {item2.obj_total_floor === 0
                                  ? 0
                                  : (
                                      item2.obj_price / item2.obj_total_floor
                                    ).toFixed(2) + "萬"}
                              </TableCell>
                              <TableCell align={"right"}>
                                {item2.obj_land_floor === 0
                                  ? 0
                                  : (
                                      item2.obj_price / item2.obj_land_floor
                                    ).toFixed(2) + "萬"}
                              </TableCell>
                              <TableCell align={"right"}>
                                {item2.obj_build_floor}
                              </TableCell>
                              <TableCell align={"right"}>
                                {item2.obj_land_floor}
                              </TableCell>
                              <TableCell align={"right"}>
                                {item2.obj_price + "萬"}
                              </TableCell>
                              <TableCell align={"right"}>
                                {(item2.obj_margin / 10000).toFixed(2) + "萬"}
                              </TableCell>
                              <TableCell align={"right"}>
                                {Boolean(item2.obj_c_floor) &&
                                Boolean(item2.obj_total_floor)
                                  ? (
                                      (item2.obj_c_floor /
                                        item2.obj_total_floor) *
                                      100
                                    ).toFixed() + "%"
                                  : 0}
                              </TableCell>
                              <TableCell align={"right"}>
                                {item2.obj_remark}
                              </TableCell>
                            </TableRow>
                          ))}
                        </>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </>
          )}
          {(printData.timePeriod === "ALL" || printData.timePeriod === "PM") &&
            printData.sourceObj.value === "司法院" &&
            (printData.timeObject.value === "ALL" ||
              printData.timeObject.value === "regular") && (
              <Box mt={1}>
                {/* Title */}
                <Grid container spacing={2}>
                  <Grid item>
                    <img
                      src={"/assets/images/Home/fullLogo2.jpg"}
                      style={{
                        maxWidth: "250px",
                        maxHeight: "88px",
                        objectFit: "contain",
                      }}
                    />
                  </Grid>
                  <Grid item style={{ flex: 1 }}>
                    <Typography> https://new.5137.com.tw</Typography>
                    <Typography>台中市南屯區大英西一街61號</Typography>
                    <Typography>(04)24717673</Typography>
                  </Grid>
                  <Grid item>
                    <Typography>{printData.courtObject.label}</Typography>
                    <Typography>{`開標時間${moment(
                      printData.summaryTableBillingDate
                    ).format("yyyy-MM-DD")} 15:00`}</Typography>
                    <Typography>{`資料筆數：${pmCount}筆`}</Typography>
                  </Grid>
                </Grid>
                <Box mt={2}>
                  <TableContainer component={Paper}>
                    <Table className={classes.table}>
                      <TableHead>
                        <TableRow>
                          <TableCell align={"center"}>股別</TableCell>
                          <TableCell align={"center"}>案號</TableCell>
                          <TableCell align={"center"}>債務人</TableCell>
                          <TableCell align={"center"}>拍次</TableCell>
                          <TableCell align={"center"}>地址</TableCell>
                          <TableCell align={"center"}>建坪單價</TableCell>
                          <TableCell align={"center"}>地坪單價</TableCell>
                          <TableCell align={"center"}>建坪</TableCell>
                          <TableCell align={"center"}>地坪</TableCell>
                          <TableCell align={"center"}>拍賣底價</TableCell>
                          <TableCell align={"center"}>保證金</TableCell>
                          <TableCell align={"center"}>公設比</TableCell>
                          <TableCell align={"center"}>備註</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {pm.map((item, index) => (
                          <>
                            <TableRow>
                              <TableCell
                                rowSpan={item.rowLength + 1}
                                align={"center"}
                              >
                                {item.obj_share}
                              </TableCell>
                            </TableRow>
                            {item.data.map((item2) => (
                              <TableRow key={index}>
                                <TableCell align={"left"}>
                                  {item2.obj_str +
                                    "年" +
                                    item2.obj_caseno +
                                    (!!item2.obj_another &&
                                    item2.obj_another.indexOf("(") === -1 &&
                                    item2.obj_another.indexOf("-") === -1
                                      ? "(" + item2.obj_another + ")"
                                      : item2.obj_another)}
                                </TableCell>
                                <TableCell align={"center"}>
                                  {item2.obj_debtor.length > 3
                                    ? item2.obj_debtor.substr(0, 3) + "..."
                                    : item2.obj_debtor}
                                </TableCell>
                                <TableCell align={"center"}>
                                  {item2.obj_time === "0"
                                    ? "應買"
                                    : item2.obj_time}
                                </TableCell>
                                <TableCell>
                                  {item2.obj_type === "H"
                                    ? item2.obj_city +
                                      item2.obj_area +
                                      item2.obj_address
                                    : item2.obj_city +
                                      item2.obj_area +
                                      item2.obj_section +
                                      "段" +
                                      item2.obj_section_s +
                                      (item2.obj_section_s ? "小段" : "") +
                                      item2.obj_landno +
                                      (item2.obj_landno ? "地號" : "")}
                                </TableCell>
                                <TableCell align={"right"}>
                                  {item2.obj_total_floor === 0
                                    ? 0
                                    : (
                                        item2.obj_price / item2.obj_total_floor
                                      ).toFixed(2) + "萬"}
                                </TableCell>
                                <TableCell align={"right"}>
                                  {item2.obj_land_floor === 0
                                    ? 0
                                    : (
                                        item2.obj_price / item2.obj_land_floor
                                      ).toFixed(2) + "萬"}
                                </TableCell>
                                <TableCell align={"right"}>
                                  {item2.obj_build_floor}
                                </TableCell>
                                <TableCell align={"right"}>
                                  {item2.obj_land_floor}
                                </TableCell>
                                <TableCell align={"right"}>
                                  {item2.obj_price + "萬"}
                                </TableCell>
                                <TableCell align={"right"}>
                                  {(item2.obj_margin / 10000).toFixed(2) + "萬"}
                                </TableCell>
                                <TableCell align={"right"}>
                                  {Boolean(item2.obj_c_floor) &&
                                  Boolean(item2.obj_total_floor)
                                    ? (
                                        (item2.obj_c_floor /
                                          item2.obj_total_floor) *
                                        100
                                      ).toFixed() + "%"
                                    : 0}
                                </TableCell>
                                <TableCell align={"right"}>
                                  {item2.obj_remark}
                                </TableCell>
                              </TableRow>
                            ))}
                          </>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
            )}
        </Box>
      </Box>
    );
  } else {
    return null;
  }
}
